export const SUPPORT_KB_ARTICLES_QUERY = `
  query SupportKbArticles {
    supportKbArticles {
      id
      title
      content
      category
      type
      status
      createdAt
      updatedAt
    }
  }
`;

export const SUPPORT_KB_ARTICLES_PUBLISHED_QUERY = `
  query SupportKbArticlesPublished {
    supportKbArticlesPublished {
      id
      title
      content
      category
      type
      status
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_SUPPORT_KB_ARTICLE_MUTATION = `
  mutation CreateSupportKbArticle($input: CreateSupportKbArticleInput!) {
    createSupportKbArticle(input: $input) {
      id
      title
      content
      category
      type
      status
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SUPPORT_KB_ARTICLE_MUTATION = `
  mutation UpdateSupportKbArticle($input: UpdateSupportKbArticleInput!) {
    updateSupportKbArticle(input: $input) {
      id
      title
      content
      category
      type
      status
      createdAt
      updatedAt
    }
  }
`;

